module.exports = __webpack_public_path__ + "static/media/Tribune.b8e9dcd7.svg";